/**
 * The `?type=` an ad's link carries to start the first business's wizard on
 * a trade, and the name a landing gives a trade (it may not quote the type:
 * `architecture.test.ts`). English and stable: it travels in links already
 * published. A file of its own, apart from `VERTICALS`, so the landing reads
 * a link without loading every trade (`web/scripts/landing-budget.mjs`).
 */
export const LINK_SLUGS = {
    "Taller o servicio técnico": "repair-shop",
    "Distribuidora": "distributor",
    "Gimnasio": "gym",
    "Barbería o salón de belleza": "salon",
    "Restaurante o fonda": "restaurant",
    "Lavado de autos": "car-wash",
    // The trades with a page of their own under /para/<slug> (web/src/para):
    // «Crear cuenta» there starts the wizard on the trade. «pastry-shop», not
    // «bakery»: tests keep «bakery» as the slug nobody has.
    "Clínica o consultorio": "clinic",
    "Guardería": "daycare",
    "Transporte escolar": "school-bus",
    "Panadería o repostería": "pastry-shop",
    "Imprenta": "print-shop",
    "Iglesia": "church",
    "Finanzas personales": "personal-finance",
    "Contabilidad": "accounting",
    // Trades only a shared page shows (signUpType null there): their VozIA
    // example names its trade by slug (`VoziaExample.trade`).
    "Academia deportiva": "sports-academy",
    "Abogado": "lawyer",
};
/** The trade a link's `?type=` names, or null for a slug no trade has. */
export function businessTypeForLink(slug) {
    if (slug === null || slug === "")
        return null;
    return Object.keys(LINK_SLUGS).find((type) => LINK_SLUGS[type] === slug) ?? null;
}
